/*
 * This file is part of glowingblue/orell-articles.
 *
 * Copyright (c) Glowing Blue AG.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import Extend from 'flarum/common/extenders';
import Article from './models/Article';
import LiteraryWork from './models/LiteraryWork';
import LiteraryWorkPage from './components/LiteraryWorkPage';

export default [
	new Extend.Store() //
		.add('of_articles', Article)
		.add('of_literary_works', LiteraryWork),

	new Extend.Routes() //
		.add('of_article', '/work/:id/:aid', LiteraryWorkPage)
		.helper('of_article', function (article: Article, params = {}) {
			const slug = article.slug();
			const aid = '/' + article.id();

			if (article.literaryWorkId()) {
				return app.route('of_literary_work', {
					id: article.literaryWorkId() + (slug.trim() ? '-' + slug : '') + aid,
					...params,
				});
			}

			// We use the ean instead of the id, this will be handled by the ArticlePage.refresh() method.
			return app.route('of_literary_work', {
				id: article.ean() + (slug.trim() ? '-' + slug : '') + aid,
				...params,
			});
		})
		.add('of_literary_work', '/work/:id', LiteraryWorkPage)
		.helper('of_literary_work', function (workId: string | number, params = {}) {
			return app.route('of_literary_work', {
				id: workId,
				...params,
			});
		}),
];
